<template>
  <div class="content">
    <div class="columns is-multiline">
      <div class="column is-6">
        <v-card
          :title="$t('fn.title')"
          :subtitle="$t('fn.subtitle')"
          :description="$t('fn.description')"
          imgSrc=""
          :card-tags="[
            'react',
            'typescript',
            'nodejs',
            'atlassian',
            'software development'
          ]"
        />
      </div>
      <div class="column is-6">
        <v-card
          :title="$t('meiko.title')"
          :subtitle="$t('meiko.subtitle')"
          :description="$t('meiko.description')"
          imgSrc=""
          :card-tags="[
            'php',
            'jquery',
            'vue',
            'software development',
            'project management'
          ]"
        />
      </div>
      <div class="column is-6">
        <v-card
          :title="$t('school.title')"
          :subtitle="$t('school.subtitle')"
          :description="$t('school.description')"
          imgSrc=""
          :card-tags="['programming', 'project management', 'studying']"
        />
      </div>
      <div class="column is-6">
        <v-card
          :title="$t('fdf.title')"
          :subtitle="$t('fdf.subtitle')"
          :description="$t('fdf.description')"
          imgSrc=""
          :card-tags="['management', 'customer service', 'php']"
        />
      </div>
    </div>
  </div>
</template>

<script>
import vCard from "@/vue/components/vCard";
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
  name: "experience",
  mixins: [i18nMixin],
  components: {
    vCard
  }
};
</script>

<style scoped></style>

<i18n>
{
    "en": {
        "pageTitle": "Experience",
        "school": {
            "title": "Jyväskylä University of Applied Sciences (JAMK)",
            "subtitle": "Bachelor of Business Information Systems, 2007",
            "description": " "
        },
        "meiko": {
            "title": "Meiko Oy",
            "subtitle": "Software developer, 2017 - 2019",
            "description": " "
        },
        "fn": {
            "title": "Flashnode",
            "subtitle": "Backend developer, 2021 - 2022",
            "description": " "
        },
        "fdf": {
            "title": "Finnish Defence Forces",
            "subtitle": "Admin, 2012",
            "description": " "
        }
    },
    "fi": {
        "pageTitle": "Kokemus",
        "school": {
            "title": "Jyväskylän Ammattikorkeakoulu (JAMK)",
            "subtitle": "Tietojenkäsittelyn koulutusohjelma, 2007",
            "description": " "
        },
        "meiko": {
            "title": "Meiko Oy",
            "subtitle": "Ohjelmistokehittäjä, 2017 - 2019",
            "description": " "
        },
        "fn": {
            "title": "Flashnode",
            "subtitle": "Backend kehittäjä, 2021 - 2022",
            "description": " "
        },
        "fdf": {
            "title": "Puolustusvoimat",
            "subtitle": "Ylläpitäjä, 2012",
            "description": " "
        }
    }
}
</i18n>
